import React from 'react';
import Card from '../common/Card';
import ReactECharts from 'echarts-for-react';
import { motion } from 'framer-motion';

const ForecastView = () => {
  const chartOptions = {
    backgroundColor: 'transparent',
    tooltip: { trigger: 'axis', backgroundColor: '#1a1a1a', borderColor: '#333', textStyle: { color: '#eee' } },
    legend: {
      data: ['Historical Demand', 'AI Forecast'],
      textStyle: { color: '#888' },
      bottom: 0
    },
    grid: { top: 30, right: 20, bottom: 60, left: 50 },
    xAxis: {
      type: 'category',
      data: ['W1', 'W2', 'W3', 'W4', 'W5', 'W6 (Now)', 'W7', 'W8', 'W9', 'W10'],
      axisLine: { lineStyle: { color: '#333' } },
      axisLabel: { color: '#888', fontFamily: 'JetBrains Mono' }
    },
    yAxis: {
      type: 'value',
      splitLine: { lineStyle: { color: '#1a1a1a', type: 'dashed' } },
      axisLabel: { color: '#888', fontFamily: 'JetBrains Mono' }
    },
    series: [
      {
        name: 'Historical Demand',
        data: [420, 380, 450, 510, 490, 550, null, null, null, null],
        type: 'bar',
        itemStyle: { color: '#4a4a4a' }
      },
      {
        name: 'AI Forecast',
        data: [null, null, null, null, null, 550, 620, 580, 650, 710],
        type: 'line',
        smooth: true,
        lineStyle: { color: '#00f0ff', width: 3, type: 'dashed' },
        itemStyle: { color: '#00f0ff' },
        areaStyle: {
          color: {
            type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
            colorStops: [{ offset: 0, color: 'rgba(0,240,255,0.2)' }, { offset: 1, color: 'rgba(0,240,255,0)' }]
          }
        }
      }
    ]
  };

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6">
      <div className="flex justify-between items-end mb-6">
        <div>
          <h2 className="text-2xl font-bold text-white tracking-tight">Demand Forecast</h2>
          <p className="text-gray-400 mt-1">Predictive modeling based on trailing 90-day velocity.</p>
        </div>
      </div>

      <Card title="Aggregated Category Projection" className="min-h-[400px]">
         <ReactECharts option={chartOptions} style={{ height: '400px', width: '100%' }} />
      </Card>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card className="bg-sp-gray-800/50">
           <div className="text-xs text-gray-400 uppercase tracking-wider mb-2">Confidence Score</div>
           <div className="text-3xl font-mono text-sp-lime">92.4%</div>
           <div className="text-xs text-gray-500 mt-2 font-mono">Based on 14 data vectors</div>
        </Card>
        <Card className="bg-sp-gray-800/50">
           <div className="text-xs text-gray-400 uppercase tracking-wider mb-2">Trend Indication</div>
           <div className="text-xl font-mono text-sp-cyan flex items-center gap-2">
             <SafeIcon name="TrendingUp" />
             UPWARD +15%
           </div>
           <div className="text-xs text-gray-500 mt-2 font-mono">Projected 30-day delta</div>
        </Card>
        <Card className="bg-sp-gray-800/50">
           <div className="text-xs text-gray-400 uppercase tracking-wider mb-2">Suggested Action</div>
           <div className="text-sm font-medium text-white">
             Increase buffer stock for Zone A1 by 20% prior to W8.
           </div>
        </Card>
      </div>
    </motion.div>
  );
};

export default ForecastView;